import React from 'react';

import { bemCssModules } from '@cryptoboyio/mercuryo-lab/utils';

import style from '../Transactions.scss';

const cn = bemCssModules(style, 'Transactions');

export type EmptyPageType = {
  title: string;
};

export const EmptyPage: CustomFC<EmptyPageType> = ({ title }) => {
  return <div className={cn('empty')}>{title}</div>;
};

export default EmptyPage;
